import { Injectable, inject } from '@angular/core';
import { filter, first, map, of, switchMap, tap } from 'rxjs';
import { createEffect, ofType } from '@ngrx/effects';

import { BaseEffect } from '../base.effect';
import { AuthenticationService } from '@Authentication/auth-extras/authentication.service';
import { UserStateStore } from './user-state.reducer';
import { StorageService } from '@Services/storage.service';
import { AuthStore } from '../auth/auth.reducer';
import { InputService, NumberFormatService } from 'ets-fe-ng-sdk';

@Injectable()
export class UserStateEffect extends BaseEffect {
  protected readonly service = inject(AuthenticationService);
  protected readonly sS = inject(StorageService);
  protected readonly iS = inject(InputService);
  protected readonly nfS = inject(NumberFormatService);

  //#region USER GROUP
  readonly setUserGroupFromLocal = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthStore.actions.fetchUserStateDetails),
      first((x) => !!x.userProfile),
      switchMap((action) => this.service.getUserGroupFromLocal()),
      filter((x) => !!x),
      map((r) => UserStateStore.actions.userGroup.setItem({ item: r })),
    ),
  );

  readonly getUserGroupFromOnline = createEffect(() =>
    this.actions$.pipe(
      // ofType(UserStateStore.actions.userGroup.getFromOnline),
      ofType(AuthStore.actions.getUserOSucces),
      map((action) => action.userProfile.users.group),
      filter((code) => !!code),
      switchMap((action) => this.service.getUserGroupFromOnline(action)),
      map((r) => UserStateStore.actions.userGroup.getFromOnlineSuccess({ item: r })),
    ),
  );

  readonly setUserGroupFromOnlineSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(UserStateStore.actions.userGroup.getFromOnlineSuccess),
      map((r) => UserStateStore.actions.userGroup.setItem(r)),
    ),
  );

  readonly saveUserGroupToLocal = createEffect(() =>
    this.actions$.pipe(
      ofType(UserStateStore.actions.userGroup.getFromOnlineSuccess),
      switchMap((action) => this.service.saveUserGroupToLocal(action.item)),
      map((r) => UserStateStore.actions.userGroup.end()),
    ),
  );
  //#endregion

  //#region COMPANY CONFIG
  readonly setCompanyConfigFromLocal = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthStore.actions.fetchUserStateDetails),
      first((x) => !!x.userProfile),
      switchMap((action) => this.service.getUserCompanyConfigFromLocal()),
      // filter((x) => !!x),
      map((r) => UserStateStore.actions.companyConfig.setItem({ item: r })),
    ),
  );

  readonly triggerGetCompanyConfigFromOnline = createEffect(() =>
    this.actions$.pipe(
      // ofType(UserStateStore.actions.companyConfig.getFromOnline),
      ofType(AuthStore.actions.getUserOSucces),
      map((action) => action.userProfile.users.primaryCompany),
      filter((code) => !!code),
      map((code) => UserStateStore.actions.companyConfig.getFromOnline({ companyCode: code })),
    ),
  );

  readonly getCompanyConfigFromOnline = createEffect(() =>
    this.actions$.pipe(
      // ofType(UserStateStore.actions.companyConfig.getFromOnline),
      ofType(UserStateStore.actions.companyConfig.getFromOnline),
      switchMap(({ companyCode: code }) => this.service.getUserCompanyConfigFromOnline(code)),
      map((r) => UserStateStore.actions.companyConfig.getFromOnlineSuccess({ item: r })),
    ),
  );

  readonly setCompanyConfigFromOnlineSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(UserStateStore.actions.companyConfig.getFromOnlineSuccess),
      map((r) => UserStateStore.actions.companyConfig.setItem(r)),
    ),
  );

  readonly setCompanyConfig = createEffect(() =>
    this.actions$.pipe(
      ofType(UserStateStore.actions.companyConfig.setItem),
      tap((r) => this.iS.updateConfig({ timeType: r.item?.config?.timeFormat || '12H' })),
      tap((r) => this.nfS.numberFormat.set( r.item?.config?.numberFormat ?? 'AM' )),
      map((r) => UserStateStore.actions.companyConfig.end()),
    ),
  );

  readonly saveCompanyConfigToLocal = createEffect(() =>
    this.actions$.pipe(
      ofType(UserStateStore.actions.companyConfig.getFromOnlineSuccess),
      switchMap((action) => this.service.saveUserCompanyConfigToLocal(action.item)),
      map((r) => UserStateStore.actions.companyConfig.end()),
    ),
  );
  //#endregion
}
